<template>
<el-container style="min-height: 100%;">
    <el-main style="background-color: #fff;">
        <div class="_flex" style="margin-bottom: 10px;">
            <el-date-picker v-model="search.created_time" type="daterange" clearable value-format="yyyy-MM-dd" range-separator="至" start-placeholder="创建开始时间" end-placeholder="创建结束时间" size="small" placeholder="创建时间范围" style="margin-left: 10px;" />
			<el-input v-model="search.title" size="small" clearable placeholder="标题" style="width: 200px;margin-left: 10px;"/>
			<el-input v-model="search.admin_phone" size="small" clearable placeholder="编辑人账号" style="width: 200px;margin-left: 10px;"/>
			<el-select v-model="search.cate_id" size="small" clearable placeholder="分类" style="margin-left: 10px;" @visible-change="getArticleCateLists">
                <el-option v-for="(item,index) in cateArr" :key="index" :label="item.name" :value="item.id"> </el-option>
			</el-select>
            <el-button size="mini" @click="getarticleLists(1)" style="margin-left: 10px;">筛选</el-button>
            <el-button type="success" size="mini" v-permit="'/admin/article/add'" @click="open">添加</el-button>
            <el-button type="primary" size="mini" v-permit="'/admin/article/cateLists'" @click="openCate">分类</el-button>
		</div>
        <el-table :data="articleArr" stripe :header-cell-style="{ background:'#f5f5f5'}">
            <el-table-column prop="id" label="序号" width="100"></el-table-column>
            <el-table-column prop="cate_name" label="分类" ></el-table-column>
            <el-table-column prop="title" label="标题" ></el-table-column>
            <el-table-column prop="created_time" label="上传" ></el-table-column>
            <el-table-column prop="created_by" label="编辑人" >
                <template v-slot="{row}">
                    {{row.admin ? row.admin.nick_name : ''}} {{row.admin && row.admin.phone ? row.admin.phone.slice(-4) : ''}}
                </template>
            </el-table-column>
            <el-table-column prop="state_text" label="状态" ></el-table-column>
            <el-table-column prop="views" label="浏览次数" ></el-table-column>
            <el-table-column label="操作" width="180px">
                <template v-slot="{row}">
                    <el-button type="primary" size="mini" v-permit="'/admin/article/edit'" @click="edit(row)">编辑</el-button>
                    <el-button type="danger"  size="mini" v-permit="'/admin/article/del'" @click="del(row.id)">删除</el-button>
                </template>
            </el-table-column>
            </el-table>
		
		<el-dialog :title="articleForm.id > 0 ? '编辑' : '新增'" :visible="show" width="70%" center destroy-on-close @close="handleClose">
            <el-form label-position="right" label-width="80px" :model="articleForm" class="pr_20">
            <el-scrollbar style="height: 60vh;">
		    <el-form-item label="标题：">
		      <el-input v-model="articleForm.title"></el-input>
		    </el-form-item>
		    <el-form-item label="排序：">
		      <el-input v-model="articleForm.sort"></el-input>
		    </el-form-item>
			<el-form-item label="分类：">
		      <el-select v-model="articleForm.cate_id" class="w_100" placeholder="请选择" @visible-change="getArticleCateLists">
		          <el-option v-for="(item,index) in cateArr" :key="index" :label="item.name" :value="item.id"> </el-option>
		        </el-select>
		    </el-form-item>
            <el-form-item label="员工：">
                <el-button type="success" size="mini" @click="selectAdminVisible = true">选择员工</el-button>
                <span style="margin-left: 10px;color: #999;">没选择员工时所有员工都能查看</span>
                <div style="width: 60%;display: grid; grid-template-columns: repeat(5, 1fr); gap: 10px;margin-top: 10px;">
                    <el-tag v-for="admin in articleForm.to_admin_id" :key="admin.admin_id" closable 
                        style="font-size: 16px;" @close="rmAdmin(admin.admin_id)"
                    >{{admin.nick_name}} {{admin.phone.slice(-4)}}</el-tag>
                </div>
            </el-form-item>
		    <el-form-item label="附件：" style="width: 600px;">
                <el-upload multiple :limit="3" action="" :http-request="Uploadhandler" :on-remove="handleRemove" :file-list="articleForm.file">
                    <el-button size="small" type="primary" v-loading="uploading">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip"></div>
                </el-upload>
		    </el-form-item>
            <el-form-item label="内容：">
                <quill-editor ref="editor" v-model="articleForm.content" class="editor" :options="{}" style="width: 90%;height: 300px;margin-bottom: 50px;"/>
		    </el-form-item>
            </el-scrollbar>
		  </el-form>
          <span slot="footer">
            <el-button @click="show = false">取 消</el-button>
            <el-button type="primary" @click="submit" :loading="loading">确 定</el-button>
          </span>
		</el-dialog>
		
		<el-dialog title="分类" :visible="represShow" width="800px" center @close="represShow=false">
		  <el-form label-position="top" label-width="90px" :model="formData" class="pr_20">
			  <el-row :gutter="30">
			    <el-col :span="16">
					<el-tabs v-model="cateForm.type" type="card" @tab-click="handleTabChange">
					    <el-tab-pane label="文档分类" name="1"></el-tab-pane>
					    <el-tab-pane label="通知分类" name="2"></el-tab-pane>
					    <el-tab-pane label="短息模板分类" name="3"></el-tab-pane>
					</el-tabs>
					<div class="_scroll" style="min-height: 100px;max-height: 300px;">
						<div class="p_10 bb1se" v-for="item in cateArr" :key="item.id">
                            <span style="cursor: pointer;" @click="handleCateEdit(item)">{{item.name}}</span>
                            <a class="red el-icon-delete fr" v-permit="'/admin/article/cateDel'" @click="handleCateDel(item.id)"></a>
                        </div>
					</div>
				</el-col>
				<div class="br1se" style="position: absolute;height: 100%;left: 68%;"></div>
			    <el-col :span="1">&nbsp;</el-col>
				<el-col :span="7">
					<div>{{cateTitle}}</div>
					<div class="mt_30 mb_10">分类名称：</div>			  
					<el-input placeholder="标题" v-model="cateForm.name" size="small" class="w200 ml_10"/>
				</el-col>
			  </el-row>
		    <div class="t_c mt_20">
				<el-button @click="represShow=false">取 消</el-button>
				<el-button type="primary" v-permit="'/admin/article/cateEdit'" @click="submitCate">确 定</el-button>
                <el-button type="success" v-permit="'/admin/article/cateAdd'" @click="handleCateAdd" v-if="cateForm.id != 0">新增分类</el-button>
		    </div>
		  </el-form>
		</el-dialog>
		
        <el-dialog title="选择员工" :visible="selectAdminVisible" width="800px" center destroy-on-close @close="selectAdminVisible=false">
            <AdminSelect v-if="selectAdminVisible" v-model="articleForm.to_admin_id" @close="selectAdminVisible=false"></AdminSelect>
        </el-dialog>
    </el-main>
    <el-footer class="foot" style="display: flex;align-items: center;background-color: #fff;">
        <div style="margin-left: auto;">
            <el-pagination background @size-change="changeLimit" @current-change="changePage" :current-page="search.page" :page-size="search.limit" layout="total, sizes, prev, pager, next, jumper" :total="search.total"></el-pagination>
        </div>
    </el-footer>
</el-container>
</template>
<script>
import AdminSelect from "@/components/select/AdminSelect.vue"
import { articleLists, articleAdd, articleEdit, articleDetail, articleDel, articleCateLists, articleCateAdd, articleCateEdit, articleCateDel, uploadFile, uploadImg } from "@/request/apis.js"
export default{
    components: { AdminSelect },
    data(){
        return {
			name:'',
			show : false,
			represShow : false,
			formData : {
				name : ''
			},

            articleArr: [],
            search: {
                page: 1,
                limit: 10,
                total: 0,
                title: '',
                created_time: [],
                admin_phone: '',
                cate_id: '',
            },
            articleFormInit: {},
            articleForm: {
                id: 0,
                type: 1,
                cate_id: '',
                title: '',
                sort: 50,
                content: '',
                file: [],
                to_admin_id: [],
            },

            currentCateType: 1,
            cateArr: [],
            cateTitle: '新增分类',
            cateFormInit: {},
            cateForm: {
                type: '1',
                id: '',
                name: '',
            },
            loading: false,
            selectAdminVisible: false,
            uploading: false,
        }
    },
    activated() {
        console.log('notice activated', this.$route);
        this.cateForm.type = this.$route.path == '/archive' ? 1 : 2;
        this.articleFormInit = JSON.parse(JSON.stringify(this.articleForm));
        this.cateFormInit = {...this.cateForm};
        this.getarticleLists();
    },
	methods:{
        async getarticleLists(page){
            if(page){
                this.search.page = page;
            }
            this.articleArr = [];
            let res = await articleLists({type: this.cateForm.type, ...this.search});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.articleArr = res.data;
            this.search.total = res.count;
        },
        changePage(page){
            this.getarticleLists(page);
        },
        changeLimit(limit){
            this.search.limit = limit;
            this.getarticleLists(1);
        },
        open(){
            this.articleForm = JSON.parse(JSON.stringify(this.articleFormInit));
            this.loading = false;
            this.show = true;
            this.afterOpenEdit();
        },
        afterOpenEdit() {
            this.$nextTick(() => { //需要等待组件渲染完成再获取
                console.log('afterOpenEdit', this.$refs)
                const quill = this.$refs.editor.quill;
                // 获取工具栏模块
                const toolbar = quill.getModule('toolbar');
                // 监听图片按钮的点击事件
                toolbar.addHandler('image', this.handleImageClick);
            });
        },
        handleImageClick() {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/*';
            input.onchange = (event) => this.handleFileChange(event);
            input.click();
        },
        handleFileChange(event) {
            const file = event.target.files[0];
            const formData = new FormData();
            formData.append('image', file);
            formData.append("category", '1');
            uploadImg(formData).then(res => {
                console.log('uploadImg', res);
                if (res == -1) {
                    return this.$message.error('上传失败');
                }
                this.$message.success('上传成功！');
                const quill = this.$refs.editor.quill;
                const range = quill.getSelection();
                quill.clipboard.dangerouslyPasteHTML(range.index,
                    `<img src="${res}">`);
            }).catch(error => {
                console.log(error);
            });
        },
        handleClose(){
            this.articleForm = JSON.parse(JSON.stringify(this.articleFormInit));
            this.show = false;
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
            this.articleForm.file = fileList;
        },
        Uploadhandler(param) {
            console.log('Uploadhandler', param)
            this.uploading = true;
            const formData = new FormData();
            formData.append("file", param.file);
            formData.append("category", '1');
            uploadFile(formData).then(res => {
                this.uploading = false;
                if (res != -1) {
                    this.articleForm.file.push({url: res, name: param.file.name, uid: ''});
                } else {
                    this.$message.error(res.msg);
                }
            }).catch(err => {
                this.uploading = false;
            })
        },
        async edit(row){
            let res = await articleDetail({id: row.id});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.getArticleCateLists(true);
            this.articleForm = {...this.articleForm, ...res.data};
            this.loading = false;
            this.show = true;
            this.afterOpenEdit();
        },
        rmAdmin(admin_id){
            this.articleForm.to_admin_id = this.articleForm.to_admin_id.filter(item => item.admin_id !== admin_id);
        },
        async submit(){
            if(this.uploading){
                return this.$message.error('请等待上传完成!');
            }
            console.log('submit', this.articleForm.to_admin_id)
            let res;
            this.loading = true;
            if(this.articleForm.id){
                res = await articleEdit({...this.articleForm, to_admin_id: this.articleForm.to_admin_id.map(v => v.admin_id).join(',')});
            }else{
                this.articleForm.type = this.cateForm.type;
                res = await articleAdd({...this.articleForm, to_admin_id: this.articleForm.to_admin_id.map(v => v.admin_id).join(',')});
            }
            this.loading = false;
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg || '操作成功');
            this.handleClose();
            this.getarticleLists();
        },
        del(id){
            this.$confirm('数据删除不可恢复，请谨慎操作！, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var res = await articleDel({id});
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg);
                this.getarticleLists();
            }).catch(() => { });
        },
        openCate(){
            this.cateForm = {...this.cateFormInit};
            this.getArticleCateLists(true);
            this.represShow = true;
        },
        handleTabChange(){
            this.cateForm = {...this.cateFormInit, type: this.cateForm.type};
            this.getArticleCateLists(true);
        },
        async getArticleCateLists(query) {
            if(!query){
                return;
            }
            this.cateArr = [];
            let res = await articleCateLists({type: this.cateForm.type});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.cateArr = res.data;
        },
        handleCateEdit(row){
            this.cateTitle = '编辑分类';
            this.cateForm = row;
        },
        async submitCate(){
            let res;
            if(this.cateForm.id){
                res = await articleCateEdit(this.cateForm);
            }else{
                res = await articleCateAdd(this.cateForm);
            }
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg || '操作成功');
            this.getArticleCateLists(true);
            if(!this.cateForm.id){
                this.cateForm.name = '';
            }
        },
        handleCateDel(id){
            this.$confirm('分类删除不可恢复，请谨慎操作！, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var res = await articleCateDel({id});
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg);
                this.getArticleCateLists(true);
            }).catch(() => { });
        },
        handleCateAdd(){
            this.cateForm = {...this.cateFormInit};
            this.cateTitle = '新增分类';
        },
	}
}
</script>

<style  scoped>
/deep/.el-scrollbar .el-scrollbar__wrap { overflow-x: hidden; }
</style> 